export default __webpack_public_path__ + "static/media/loading.f2805faa.gif";